import { render, staticRenderFns } from "./CmsInsureClaim.vue?vue&type=template&id=6810a218&scoped=true&"
import script from "./CmsInsureClaim.vue?vue&type=script&lang=js&"
export * from "./CmsInsureClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6810a218",
  null
  
)

export default component.exports